import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Icon} from '../../../../uiToolkit/Icon/Icon';
import NavListItem from './NavListItem';

interface NavItem {
  icon: any;
  title: string;
  slug: string;
  route: string;
  activeIcon: any;
  permission?: string;
  reqireSubscription?: boolean;
  badge?: string;
}

interface Props extends NavItem {
  items: NavItem[];
  activeRoute: string;
  userPermissions: string[];
  collapsed: boolean;
  hasSubscription?: boolean;
}

const NavGroupItem = React.memo(
  ({
    title,
    route,
    icon,
    slug,
    items,
    activeRoute,
    userPermissions,
    permission,
    collapsed,
    hasSubscription,
  }: Props) => {
    const isOwnRoute = activeRoute === route;

    const visibleChildren = items.filter(
      child => !child.reqireSubscription || hasSubscription,
    );

    const activeChildRoute = visibleChildren
      .filter(child => activeRoute.startsWith(child.route))
      .reduce(
        (best, child) =>
          child.route.length > best.length ? child.route : best,
        '',
      );

    const holdsActiveRoute = isOwnRoute || !!activeChildRoute;

    const [expanded, setExpanded] = useState(true);

    useEffect(() => {
      if (holdsActiveRoute) {
        setExpanded(true);
      }
    }, [holdsActiveRoute]);

    if (permission && !userPermissions.includes(permission)) {
      return <div />;
    }

    return (
      <>
        <div
          className={`NavListItemContainer NavGroupContainer ${
            isOwnRoute ? 'activeRouteLink' : ''
          } ${collapsed ? 'NavListItemCollapsed' : ''}`}>
          <Link
            to={route}
            className={`MainRouteLink ${slug} ${
              collapsed ? 'MainRouteLinkCollapsed' : ''
            }`}>
            <Icon name={icon} className="NavIcon" />
            {!collapsed && (
              <span className={isOwnRoute ? 'Active' : ''}>{title}</span>
            )}
          </Link>
          {!collapsed && (
            <button
              className={`NavGroupToggle ${expanded ? 'NavGroupExpanded' : ''}`}
              onClick={() => setExpanded(!expanded)}
              aria-expanded={expanded}
              aria-label={title}>
              <span className="icon-chevron-right" />
            </button>
          )}
        </div>
        {!collapsed && expanded && (
          <div className="NavGroupChildren">
            {visibleChildren.map(child => (
              <NavListItem
                {...child}
                activeRoute={activeRoute}
                isActive={child.route === activeChildRoute}
                key={child.title}
                userPermissions={userPermissions}
                collapsed={collapsed}
              />
            ))}
          </div>
        )}
      </>
    );
  },
);

export default NavGroupItem;
